<template>
  <div class="centivo plan-affiliations-form-wrapper">
    <div class="plan-affiliations-form">
      <div>
        <div class="plan-affiliation-content">
          <span class="steps">1</span>
          <p>Select the plan type</p>
        </div>

        <div class="plans-switch">
          <b-field>
            <b-radio
              size="is-large"
              native-value="Javelina"
              :value="planAffiliation.planType"
              @input="$emit('plan-type-change', $event)"
            >
              Javelina
            </b-radio>
          </b-field>
          <b-field>
            <b-radio
              size="is-large"
              native-value="HRP"
              :value="planAffiliation.planType"
              @input="$emit('plan-type-change', $event)"
            >
              HRP
            </b-radio>
          </b-field>
        </div>
      </div>

      <div v-if="planAffiliation.planType">
        <div class="plan-affiliation-content">
          <span class="steps">2</span>
          <p>
            Select the client ID to affiliate the configurations to the plan
          </p>
        </div>
        <form>
          <DropDownComponent
            class="client-id-dropdown"
            :name="planAffiliation.clientId"
            :planType="planAffiliation.planType"
            label="Client ID"
            :options="planAffiliation.clientOptions"
            @update:selectedOption="$emit('client-id-change', $event)"
          />
        </form>
      </div>

      <div
        v-if="
          planAffiliation.selectedClient &&
          planAffiliation.selectedClient.title !== 'NONE' &&
          planAffiliation.clientId != 'NONE'
        "
      >
        <div class="plan-affiliation-content">
          <span class="steps">3</span>
          <p>Select a network name to affiliate to each plan ID</p>
        </div>

        <div class="table-wrapper">
          <div class="table-header">
            <p>PLAN ID</p>
            <p>NETWORK NAME</p>
          </div>
          <div class="table-content" v-if="planAffiliation.selectedClient">
            <div
              v-for="item in planAffiliation.selectedClient.plans ?? []"
              :key="item.planId"
              class="plans-list"
            >
              <div class="plan-id" v-if="item.planId">{{ item.planId }}</div>
              <form>
                <DropDownComponent
                  :name="item.planId"
                  :options="item.networkAffiliationOptions"
                  @update:selectedOption="$emit('network-affiliation-change', $event)"
                  v-if="item.planId"
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DropDownComponent from './../form/DropDownComponent.vue'

export default {
  components: {
    DropDownComponent
  },
  props: {
    planAffiliation: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped></style>
